// ────────────────────────────────────────────────────────────────
// Page « Réinitialiser le mot de passe » — depuis le lien reçu par email
// ────────────────────────────────────────────────────────────────
import { useState } from "react";
import api from "../services/api";
import "../styles/design-tokens.css";

export default function ResetPassword({ onGoToLogin }) {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [password, setPassword]               = useState("");
  const [passwordConfirm, setPasswordConfirm]  = useState("");
  const [done, setDone]       = useState(false);
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 8) {
      setError("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (password !== passwordConfirm) {
      setError("Les deux mots de passe ne correspondent pas.");
      return;
    }

    setLoading(true);
    try {
      await api.auth.resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    fontFamily: "Inter, sans-serif",
    width: "100%", padding: "10px 12px", background: "var(--ink)",
    border: "0.5px solid var(--hairline)", borderRadius: 8, color: "var(--text)",
    fontSize: 13, outline: "none", boxSizing: "border-box",
  };

  return (
    <div className="exp-public" style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(135deg, var(--ink) 0%, var(--surface) 55%, var(--surface-2) 100%)",
    }}>
      <div style={{ width: "100%", maxWidth: 400, padding: "0 16px" }}>

        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <img src="/assets/logo-icon-execpro360.png" alt="ExecPro360" style={{ width: 40, height: 40, marginBottom: 12, objectFit: "contain" }} />
          <div style={{ fontFamily: "Manrope, sans-serif", fontSize: 22, fontWeight: 800, color: "var(--text)" }}>ExecPro360</div>
        </div>

        {/* Carte */}
        <div style={{
          background: "var(--surface)", border: "0.5px solid var(--hairline)",
          borderRadius: 16, padding: "28px 24px",
        }}>
          <h2 style={{ fontFamily: "Manrope, sans-serif", fontSize: 16, fontWeight: 700, color: "var(--text)", margin: "0 0 6px" }}>
            Nouveau mot de passe
          </h2>

          {!token ? (
            <p style={{ fontFamily: "Inter, sans-serif", fontSize: 13, color: "var(--text-muted)", margin: "20px 0 0" }}>
              Lien de réinitialisation manquant. Vérifiez que vous avez bien cliqué sur le lien reçu par email.
            </p>
          ) : done ? (
            <>
              <div style={{
                fontFamily: "Inter, sans-serif",
                padding: "12px 14px", background: "var(--brand-tint)", border: "0.5px solid var(--brand)",
                borderRadius: 8, fontSize: 13, color: "var(--text)", lineHeight: 1.6, marginTop: 20,
              }}>
                ✅ Mot de passe réinitialisé. Vous pouvez maintenant vous connecter.
              </div>
              <button
                onClick={onGoToLogin}
                style={{
                  fontFamily: "Manrope, sans-serif",
                  width: "100%", padding: "11px", background: "var(--brand)",
                  border: "none", borderRadius: 8, color: "#fff",
                  fontSize: 13, fontWeight: 700, cursor: "pointer", marginTop: 16,
                }}
              >
                Se connecter
              </button>
            </>
          ) : (
            <>
              <p style={{ fontFamily: "Inter, sans-serif", fontSize: 12, color: "var(--text-muted)", margin: "0 0 20px" }}>
                Choisissez un nouveau mot de passe pour votre compte.
              </p>

              {error && (
                <div style={{
                  fontFamily: "Inter, sans-serif",
                  padding: "10px 12px", background: "#3b1c1c", border: "0.5px solid #e24b4a",
                  borderRadius: 8, fontSize: 12, color: "#fca5a5", marginBottom: 16,
                }}>
                  ⚠️ {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ fontFamily: "Manrope, sans-serif", fontSize: 12, color: "var(--text-muted)", display: "block", marginBottom: 6 }}>
                    Nouveau mot de passe
                  </label>
                  <input
                    type="password" required value={password} onChange={e => setPassword(e.target.value)}
                    placeholder="8 caractères minimum" minLength={8} autoFocus
                    style={inputStyle}
                  />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ fontFamily: "Manrope, sans-serif", fontSize: 12, color: "var(--text-muted)", display: "block", marginBottom: 6 }}>
                    Confirmer le mot de passe
                  </label>
                  <input
                    type="password" required value={passwordConfirm} onChange={e => setPasswordConfirm(e.target.value)}
                    placeholder="8 caractères minimum" minLength={8}
                    style={inputStyle}
                  />
                </div>

                <button
                  type="submit" disabled={loading}
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    width: "100%", padding: "11px", background: loading ? "var(--brand-hover)" : "var(--brand)",
                    border: "none", borderRadius: 8, color: "#fff",
                    fontSize: 13, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer",
                    transition: "background 0.2s",
                  }}
                >
                  {loading ? "Réinitialisation en cours..." : "Réinitialiser mon mot de passe"}
                </button>
              </form>
            </>
          )}

          <div style={{ fontFamily: "Inter, sans-serif", textAlign: "center", marginTop: 16, fontSize: 12, color: "var(--text-muted)" }}>
            <span
              style={{ fontFamily: "Manrope, sans-serif", color: "var(--brand)", cursor: "pointer", fontWeight: 600 }}
              onClick={onGoToLogin}
            >← Retour à la connexion</span>
          </div>
        </div>
      </div>
    </div>
  );
}
